/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 15.06.24
 *
 */

import {ReminderItem} from "@shared/scheduler/reminders/reminderItem-imports";
import {ReminderType} from "@shared/scheduler/reminders/ReminderType";

export default class CalendarReminderItem extends ReminderItem {

	summary: string = null
	description: string = null

	calendarId: string = null
	gCalendarEventId: string = null
	outlookEventId: string = null
	iCloudEventId: string = null


	constructor(trigger) {
		super(ReminderType.CALENDAR, trigger);
	}

	createQwoachEvent() {
		let qwoachEvent = super.createQwoachEvent()

		qwoachEvent.name = this.summary

		qwoachEvent.googleEventId = this.gCalendarEventId
		qwoachEvent.outlook365EventId = this.outlookEventId
		qwoachEvent.iCloudEventId = this.iCloudEventId
		qwoachEvent.calendarId = this.calendarId

		return qwoachEvent
	}

	onDelete(){
		super.onDelete()
		this.gCalendarEventId = null
		this.outlookEventId = null
		this.iCloudEventId = null
		this.calendarId = null
	}


	syncFromQwoachEvent(qwoachEvent){
		super.syncFromQwoachEvent(qwoachEvent)

		this.gCalendarEventId = qwoachEvent.googleEventId
		this.outlookEventId = qwoachEvent.outlook365EventId
		this.iCloudEventId = qwoachEvent.iCloudEventId
		this.calendarId = qwoachEvent.calendarId

	}



}
